import { render, staticRenderFns } from "./TableList.vue?vue&type=template&id=489a085b"
import script from "./TableList.vue?vue&type=script&lang=js"
export * from "./TableList.vue?vue&type=script&lang=js"
import style0 from "./TableList.vue?vue&type=style&index=0&id=489a085b&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports